import { render, staticRenderFns } from "./OpportunitiesMartketingLeadList.vue?vue&type=template&id=684cf11a&scoped=true&"
import script from "./OpportunitiesMartketingLeadList.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesMartketingLeadList.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitiesMartketingLeadList.vue?vue&type=style&index=0&id=684cf11a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684cf11a",
  null
  
)

export default component.exports